import { render } from "./AddEditCustomer.vue?vue&type=template&id=feec8bb6"
import script from "./AddEditCustomer.vue?vue&type=script&lang=js"
export * from "./AddEditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__